<style lang="sass">
  .uk-panel-box
    /*color: #ffffff;*/
  .uk-breadcrumb
    margin-top: 50px !important
</style>

<template transition="fade" transition-mode="out-in">
  <div class="uk-container uk-container-center uk-margin-top uk-margin-large-bottom main-container">
<ul class="uk-breadcrumb">
  <li><a href="#">Home</a></li>
  <li class="uk-active"><span>Book a Visit</span></li>
</ul>

<div class="uk-grid" data-uk-grid-margin>

  <div class="uk-width-1-1">
    <h1>Book a Farm Visit</h1>
    <p class="uk-text-large">Visit one of our partner farms to learn the basics of farming
      <button class="uk-button-mini uk-button-primary uk-button uk-margin-left" data-uk-modal="{target:'#more',center:true}"> Learn More </button>
    </p>
    <div id="more" class="uk-modal">
    <div class="uk-modal-dialog">
      <a class="uk-modal-close uk-close"></a>

        <div class="uk-modal-header uk-text-center"><h2>Farm Visit FAQ</h2></div>
        <ol>
          <li>
            <strong> What is a farm visit?</strong>
            <p>It is a learning experience at one of our partner farms where you get to interact with experts and learn the best practices from them</p>
          </li>
          <li>
            <strong> How do I view a farm?</strong>
            <p> Click on one of the farms </p>
          </li>
          <li>
            <strong> How many farms are there on Kuza? </strong>
            <p>We are currently working on bringing more quality farms onto our platform.</p>
          </li>
          <li>
            <strong> I have a farm. How do I get it listed on Kuza?</strong>
            <p> Call <a href="tel:+254718411704">+254718411704</a> or email <a href="mailto:farm@kuza.io"> farm@kuza.io </a> and we'll get back to you. </p>
          </li>
        </ol>
        <div class="uk-modal-footer uk-text-center"></div>
    </div>
</div>
  </div>
  <div v-if="$loadingRouteData" class="uk-align-center uk-vertical-align" style="height: 50vh;">
    <div class="uk-vertical-align-middle">
      <i style="color: #87AB61" class="uk-icon-circle-o-notch uk-icon-large uk-icon-spin"></i>
    </div>
  </div>
  <div v-if="!$loadingRouteData" class="uk-width-medium-1-2 uk-grid-margin uk-row-first" v-for="farm in farms" transition="expand">

    <div class="uk-panel uk-panel-box-hover">

      <div class="uk-panel-teaser">
        <figure class="uk-overlay uk-vertical-align">
          <img :src="farm.images[0]" alt="" data-src="farm.images[0]" data-holder-rendered="true">
          <figcaption class="uk-overlay-panel uk-overlay-background uk-overlay-bottom uk-vertical-align-middle">
            <h3>{{farm.title}}</h3>
            <p class="uk-text-truncate" v-if=farm.description>{{farm.description}}</p>
            <p>
              <span class="uk-align-left" v-if=farm.duration><i class="uk-icon-clock-o uk-icon-small uk-margin-right"></i>{{farm.duration}}</span>
              <span class="uk-align-right"  v-if=farm.location><i class="uk-icon-map-marker uk-icon-small uk-margin-right"></i>{{farm.location}}</span>
            </p>
          </figcaption>
        </figure>
      </div>
      <a class="uk-position-cover" v-on:click="openFarm(farm)"></a>

    </div>

  </div>

</div>
  </div>
</template>

<script>
  import store from '../store'

  export default {
    name: 'Farms',

    firebase: {
      farms: store.farms.limitToLast(25)
    },
    route: {
      data(transition) {
        window.setTimeout(() => {
          // the vue-loading will closed after next().
          if(this.farms.length) transition.next();
        }, 3000);
      }
    },
    methods: {
      openFarm: function(farm) {
        store.farm = farm
        this.$router.go({
          name: 'farm',
          params: {
            slug: farm.slug
          }
        })
      }
    }

  }
</script>


/** WEBPACK FOOTER **
 ** Farms.vue?725e4ee6
 **/